import {
  Fee,
  Fuelling,
  Insurance,
  Licensing,
  Maintenance,
  Repair,
  Ticket,
  VehicleRevenue,
} from "@/interfaces";
import api from "@/lib/axios";

export interface ExpensesReportRequest {
  start_date: string;
  end_date: string;
  vehicle_id: string;
  categories: string;
}

export interface ExpensesYearlyReportRequest {
  year: number;
}

export interface VehicleInfo {
  id: number;
  title: string;
  plate: string;
  status: string;
}

export interface ExpenseCategories {
  fuelling: {
    history: Fuelling[];
    total: number;
  };
  licensing: {
    history: Licensing[];
    total: number;
  };
  maintenance: {
    history: Maintenance[];
    total: number;
  };
  ticket: {
    history: Ticket[];
    total: number;
  };
  otherFees: {
    history: Fee[];
    total: number;
  };
  repair: {
    history: Repair[];
    total: number;
  };
  insurance: {
    history: Insurance[];
    total: number;
  };
  total: number;
}

export interface ExpensesReportItemResponse {
  categories: ExpenseCategories;
  vehicle: VehicleInfo;
  total: number;
  revenues: {
    history: VehicleRevenue[];
    total: number;
  };
  net_result: number;
}

export interface ExpensesReportResponse {
  errors: boolean;
  data: {
    [key: string]: ExpensesReportItemResponse;
  };
}

export interface YearlyReportMonth {
  name: string;
  previous_year: {
    total: number;
    categories: {
      [key: string]: number;
    };
  };
  current_year: {
    total: number;
    categories: {
      [key: string]: number;
    };
  };
}

export interface YearlyReportVehicle {
  id: number;
  plate: string;
  title: string;
  total: number;
  last_year_total: number;
  categories: {
    [key: string]: number;
  };
}

export interface YearlyReportResponse {
  errors: boolean;
  data: {
    months: YearlyReportMonth[];
    categories: {
      [key: string]: {
        current_year: number;
        previous_year: number;
      };
    };
    variations: {
      [key: string]: number;
    };
    vehicles: {
      [key: string]: YearlyReportVehicle;
    };
  };
}

export const expensesReportService = {
  getExpensesReport: async (params: ExpensesReportRequest) => {
    const response = await api.get<ExpensesReportResponse>("expenses_report", {
      params,
    });
    return response.data;
  },

  getExpensesPdfReport: async (params: ExpensesReportRequest) => {
    const response = await api.get("expenses_report/pdf", {
      params,
      responseType: "blob",
    });
    return response.data;
  },

  getYearlyExpensesReport: async (params: ExpensesYearlyReportRequest) => {
    const response = await api.get<YearlyReportResponse>(
      "expenses_report/yearly",
      { params },
    );
    return response.data;
  },
};
